<template>
  <div v-if="visible" class="recall-wrapper">
    <div class="cover-title">
      <div class="title-box">
        <div class="title-text flex-center">{{ $$t("common.welcome_back") }}</div>
        <div class="title-desc">{{ $$t("common.reactivate_and_enjoy") }}</div>
      </div>
    </div>
    <div class="cover">
      <img src="@/assets/img/credit/reward1.webp" />
    </div>
    <div class="button" @click="confirmCredit">
      {{ $$t("common.claim_4free_credits") }}
    </div>
    <!-- <div class="close-mobile" @click="closeCredit">
      <img src="@/assets/img/release/credit_close.png" />
    </div> -->
  </div>
</template>

<script setup>
import {
  getCreditReadStatus,
  setCreditReadStatus,
} from "@/api/api/apiStore.js";
import { ref, watchEffect, defineProps, defineEmits, getCurrentInstance } from "vue";
import { isMobileDevice } from "@/utils/tools.js";
import useUserDataStore from "@/store/userDataStore";
import message from "@/components/functionCallComponent/message/message.js";
import { useRouter } from "vue-router";
import useDialogStore from "@/store/dialogStore.js";
const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;
const { $$t, $$language } = globalProperties?.$i18n ?? {};
const Router = useRouter();
const userDataStore = useUserDataStore();
const dialogStore = useDialogStore();

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});
const emits = defineEmits(["handleView"]);

const confirmCredit = () => {
  emits("update:visible", false);
  dialogStore.getPopupShow();
  Router.push({
    name: "create",
  });
  // message.success({
  //   position: "top",
  //   content: "Successfully claimed",
  // });
};

const goCredit = () => {
  showRewardCustomer.value = false;
  emits("handleView");
};
</script>

<style lang="scss" scoped>
.recall-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0 !important;
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  z-index: 999;
  &.mobile {
    justify-content: flex-end;
  }
  .title-box {
    text-align: center;
    .title-text {
      font-size: 48px;
      font-weight: bold;
      background: linear-gradient(275deg, #4fdeff 2%, #ffffff 54%, #e675ff 101%),
        #ffffff;
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      // padding: 0 40px 0 40px;
      &::before {
        content: "";
        margin-right: 12px;
        height: 52px;
        width: 44px;
        background-image: url("@/assets/img/credit/star2.png");
        background-repeat: no-repeat;
        background-size: cover;
      }
      &::after {
        content: "";
        margin-left: 12px;
        height: 32px;
        width: 32px;
        background-image: url("@/assets/img/credit/star1.png");
        background-repeat: no-repeat;
        background-size: cover;
      }
    }
    .title-desc {
      margin-top: 6px;
      font-size: 28px;
      font-weight: 400; /* 可选，设置加粗 */
      background: linear-gradient(275deg, #4fdeff 2%, #ffffff 54%, #e675ff 101%),
        #ffffff;
      -webkit-background-clip: text; /* 让背景渐变显示在文字上 */
      background-clip: text; /* 兼容标准 */
      color: transparent; /* 让文字本身透明 */
    }
  }
  .mobile-cover {
    width: 100%;
  }
  .block {
    position: absolute;
    bottom: 0;
    height: 188px;
    width: 100%;
    border-radius: 20px;
    display: flex;
    gap: 24px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: linear-gradient(26deg, #e3faff 16%, #f9dcff 94%);
    .button {
      font-weight: 500;
    }
  }
  .close,
  .close-mobile {
    img {
      height: 40px;
      width: 40px;
      cursor: pointer;
    }
    &:hover {
      opacity: 0.9;
    }
  }
  .close {
    position: absolute;
    right: -60px;
    top: 5px;
    img {
      // transform: translateX(190px);
    }
  }
  .close-mobile {
    display: none;
  }
  .cover-title {
    position: relative;
    .tit-img {
      display: block;
      width: 490px;
      height: 95px;
    }
  }
  .cover > img {
    display: block;
    width: 430px;
    height: 362px;
  }
  .button {
    margin-top: 10px;
    width: 378px;
    height: 60px;
    border-radius: 78px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(99deg, #4fdeff 0%, #e675ff 100%);
    font-size: 16px;
    font-weight: bold;
    line-height: 28px;
    color: #000000;
    cursor: pointer;

    &:hover {
      opacity: 0.9;
    }
  }
}

@media screen and (max-width: 768px) {
  .recall-wrapper {
    background: rgba(0, 0, 0, 0.8);
    .title-box {
      .title-text {
        font-size: 34px;
        &::before {
          height: 42px;
          width: 35px;
        }
        &::after {
          height: 28px;
          width: 28px;
        }
      }
      .title-desc {
        font-size: 18px;
        padding: 0 20px;
      }
    }
    .button {
      margin-top: 10px;
      width: 280px;
      height: 48px;
      font-size: 14px;
    }
    .close {
      display: none;
    }
    .close-mobile {
      display: block;
      width: 100%;
      text-align: center;
      margin-top: 16px;
      img {
        // transform: translateX(150px);
        height: 40px;
        width: 40px;
        cursor: pointer;
        transform: none;
      }
    }
    .cover-title {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .cover-title {
      .tit-img {
        width: 80%;
        height: auto;
      }
    }
    .cover > img {
      width: 300px;
      height: auto;
    }
  }
}

@media screen and (max-width: 320px) {
  .recall-wrapper {
    .title-box {
      .title-text {
        font-size: 30px;
        &::before {
          margin-right: 8px;
        }
        &::after {
          margin-left: 8px;
        }
      }
      .title-desc {
        margin-top: 8px;
        font-size: 16px;
        padding: 0 20px;
      }
    }
    .cover {
      img {
        width: 260px;
      }
    }
    .button {
      width: 260px;
    }
  }
}
</style>
